/* ZIRAK PRICE BOX - product page only.
   Wraps Dawn's own price block + "Taxes included" line in one card and adds:
   - "Save X%" chip (only when the product has a compare-at price)
   - "Prepaid Special: Pay only <price - 5%>" row
   - "See Breakdown" panel (MRP, discount, price, prepaid saving, you pay)
   All numbers are read from the price Dawn shows, so they follow the selected variant.
   Dawn's price element is only moved, never replaced, so variant updates keep working. */
(function () {
  if (window.zpbInit) return;
  window.zpbInit = true;
  var PREPAID_PCT = 5;

  function num(t) {
    if (!t) return null;
    var m = String(t).replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  }
  function prefixOf(t) {
    var m = String(t || '').trim().match(/^[^\d]*/);
    var p = m ? m[0].trim() : '';
    return p ? p + (p.length > 1 ? ' ' : '') : '\u20b9';
  }
  function fmt(prefix, v) {
    var whole = Math.round(v * 100) / 100;
    var s = whole.toLocaleString('en-IN', { minimumFractionDigits: whole % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return prefix + s;
  }
  function readPrices(priceBox) {
    var onSale = priceBox.querySelector('.price--on-sale');
    var saleEl = onSale ? priceBox.querySelector('.price__sale .price-item--sale, .price__sale .price-item--last') : null;
    var cmpEl = onSale ? priceBox.querySelector('.price__sale s.price-item--regular, .price__sale .price-item--regular') : null;
    var regEl = priceBox.querySelector('.price__regular .price-item--regular');
    var priceText = saleEl ? saleEl.textContent : (regEl ? regEl.textContent : '');
    var price = num(priceText);
    var cmp = cmpEl ? num(cmpEl.textContent) : null;
    if (cmp !== null && price !== null && cmp <= price) cmp = null;
    return { price: price, cmp: cmp, prefix: prefixOf(priceText) };
  }

  var BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><rect x="2.5" y="6" width="19" height="12" rx="1.5"/><circle cx="12" cy="12" r="2.6"/><path d="M6 9.5v5M18 9.5v5"/></svg>';

  function build(priceBox) {
    if (priceBox.closest('.zpb')) return priceBox.closest('.zpb');
    var card = document.createElement('div');
    card.className = 'zpb';
    priceBox.parentNode.insertBefore(card, priceBox);
    var top = document.createElement('div');
    top.className = 'zpb__top';
    card.appendChild(top);
    top.appendChild(priceBox);
    top.insertAdjacentHTML('beforeend', '<span class="zpb__save" hidden></span>');

    var meta = document.createElement('div');
    meta.className = 'zpb__meta';
    card.appendChild(meta);
    // Dawn's "Taxes included. Shipping calculated at checkout." line sits right after the price block
    var sib = card.nextElementSibling;
    if (sib && sib.classList.contains('product__tax')) meta.appendChild(sib);
    meta.insertAdjacentHTML('beforeend', '<button type="button" class="zpb__toggle" aria-expanded="false">See Breakdown</button>');

    card.insertAdjacentHTML('beforeend',
      '<dl class="zpb__breakdown" hidden></dl>' +
      '<div class="zpb__prepaid"><span class="zpb__prepaid-text">' + BAG + '<span></span></span>' +
      '<span class="zpb__chip">' + PREPAID_PCT + '% Instant Off</span></div>');

    var btn = meta.querySelector('.zpb__toggle');
    var panel = card.querySelector('.zpb__breakdown');
    btn.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Hide Breakdown' : 'See Breakdown';
    });
    return card;
  }

  function update(card, priceBox) {
    var p = readPrices(priceBox);
    if (p.price === null) return;
    var key = p.price + '|' + p.cmp;
    if (card.dataset.zpbKey === key) return;
    card.dataset.zpbKey = key;

    var prepaid = Math.round(p.price * (100 - PREPAID_PCT) / 100);
    var save = card.querySelector('.zpb__save');
    if (p.cmp) {
      var pct = Math.round((p.cmp - p.price) / p.cmp * 100);
      save.textContent = 'Save ' + pct + '%';
      save.hidden = pct < 1;
    } else {
      save.hidden = true;
    }

    card.querySelector('.zpb__prepaid-text > span').innerHTML =
      'Prepaid Special: Pay only <b>' + fmt(p.prefix, prepaid) + '</b>';

    var rows = '';
    if (p.cmp) {
      rows += '<div class="zpb__row"><dt>MRP</dt><dd>' + fmt(p.prefix, p.cmp) + '</dd></div>';
      rows += '<div class="zpb__row zpb__row--minus"><dt>Discount</dt><dd>\u2212 ' + fmt(p.prefix, p.cmp - p.price) + '</dd></div>';
    }
    rows += '<div class="zpb__row"><dt>Price (taxes included)</dt><dd>' + fmt(p.prefix, p.price) + '</dd></div>';
    rows += '<div class="zpb__row zpb__row--minus"><dt>Prepaid ' + PREPAID_PCT + '% off</dt><dd>\u2212 ' + fmt(p.prefix, p.price - prepaid) + '</dd></div>';
    rows += '<div class="zpb__row zpb__row--total"><dt>You pay (prepaid)</dt><dd>' + fmt(p.prefix, prepaid) + '</dd></div>';
    card.querySelector('.zpb__breakdown').innerHTML = rows;
  }

  function run() {
    document.querySelectorAll('.product__info-container [id^="price-"]').forEach(function (priceBox) {
      if (!priceBox.querySelector('.price')) return;
      var card = build(priceBox);
      update(card, priceBox);
    });
  }

  function start() {
    run();
    var info = document.querySelector('.product__info-container');
    if (info && 'MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 60); })
        .observe(info, { childList: true, subtree: true, characterData: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
